import React from 'react';
import AgencyChildBillingRowProperties from "./AgencyChildBillingRowProperties";
import {useStyles} from "../AgencyChildBilling.style";
import clsx from "clsx";
import ShowDate from "../../../shared_components/Info/ShowDate/ShowDate";
import ShowArticleDescription from '../../../shared_components/Info/ShowArticleDescription/ShowArticleDescription';
import ShowBillingPeriodStatus from '../../../shared_components/Info/ShowBillingPeriodStatus/ShowBillingPeriodStatus';
import Typography from "@material-ui/core/Typography";
import ExpandoMenu from '../../../ui_components/ExpandoMenu/ExpandoMenu';
import DownloadSummarizedAgencyOrdersReportButton from '../../../shared_components/Buttons/DownloadSummarizedAgencyOrdersReportButton/DownloadSummarizedAgencyOrdersReportButton';
import ButtonType from '../../../ui_components/Button/ButtonType';
import { useUserContext } from '../../../contexts/UserContext';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import DownloadAgencyOrdersReportButton from '../../../shared_components/Buttons/DownloadAgencyOrdersReportButton/DownloadAgencyOrdersReportButton';

const AgencyChildBillingRow: React.FC<AgencyChildBillingRowProperties> = ({
                                                                    billingPeriod,
                                                                    onUpdate = () => {}
                                                                }) => {
    const classes = useStyles();
    const userStore = useUserContext();

    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(value);
    }

    return (
        <div className={clsx(classes.billing_period_info_container)}>
            <ShowDate label={'Início'} timestamp={billingPeriod.startDate} showTime={false}/>
            <ShowDate label={'Fim'} timestamp={billingPeriod.endDate} showTime={false}/>
            <ShowArticleDescription description={billingPeriod.description}/>
            
            <div className={classes.amount_due_container}>
                <Typography className={classes.amount_due_label}>Valor Devido</Typography>
                <Typography className={classes.amount_due_value}>{formatCurrency(billingPeriod.childAgencyAmount)}</Typography>
            </div>

            <div className={classes.status_container}>
                <ShowBillingPeriodStatus status={billingPeriod.status}/>
            </div>

            <div>
                <ExpandoMenu>
                    <>
                        <DownloadSummarizedAgencyOrdersReportButton
                            type={ButtonType.SECONDARY}
                            showPreview={true}
                            agencyId={userStore.currentUser()?.agencyId || ''}
                            from={billingPeriod.startDate}
                            to={billingPeriod.endDate}
                            size={ButtonSize.SMALL}
                        />
                        <DownloadAgencyOrdersReportButton
                            type={ButtonType.SECONDARY}
                            showPreview={true}
                            agencyId={userStore.currentUser()?.agencyId || ''}
                            from={billingPeriod.startDate}
                            to={billingPeriod.endDate}
                            size={ButtonSize.SMALL}
                        />
                    </>
                </ExpandoMenu>
            </div>
        </div>
    );
}

export default AgencyChildBillingRow;
